export function fadeIn({
  element,
  duration = 300,
  originalDisplay = 'block',
  onComplete,
}: {
  element: string | HTMLDivElement;
  duration?: number;
  originalDisplay?: string;
  onComplete?: () => void;
}): Promise<void> {
  const el: HTMLDivElement | null = typeof element === 'string' ? document.querySelector(element) : element;

  if (!el) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    el.style.display = originalDisplay;
    el.style.opacity = '0.3';
    el.style.transition = `opacity ${duration}ms linear`;
    setTimeout(() => {
      el.style.opacity = '1';
    }, 0);

    setTimeout(() => {
      el.style.transition = '';
      onComplete?.();
      resolve();
    }, duration);
  });
}
